import styled from 'styled-components';

const ValidationLine = /*#__PURE__*/styled.span.withConfig({
  componentId: "sc-storm-ui-40026394__sc-1d45qdh-0"
})([""]);
ValidationLine.displayName = 'ValidationLine';

export { ValidationLine as V };
//# sourceMappingURL=ValidationLine-DjKYKrQz.js.map
